import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { getCountryConfig } from '../../../utils/countryUtils';

const CountryMismatchModal = ({ isOpen, onClose, onRedirect, projectCountryCode, projectCountry, currentCountry }) => {
  if (!isOpen) return null;

  const projectCountryConfig = getCountryConfig(projectCountryCode);
  const currentCountryConfig = getCountryConfig(currentCountry);

  
  const projectCountryName = projectCountryConfig?.name || projectCountry || projectCountryCode;
  const currentCountryName = currentCountryConfig?.name || currentCountry;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] p-4">
      <div 
        className="bg-white rounded-lg max-w-md w-full shadow-theme-lg overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-yellow-50 to-orange-100 border-b border-yellow-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-full bg-yellow-500 flex items-center justify-center">
                <FontAwesomeIcon icon={faExclamationTriangle} className="text-white text-lg" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-900">Proyecto de otro país</h2>
                <p className="text-sm text-gray-600 mt-0.5">Ubicación incorrecta</p>
              </div>
            </div>
            {onClose && (
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p className="text-sm text-gray-700 leading-relaxed">
              Este proyecto pertenece a <strong className="font-semibold text-gray-900">{projectCountryName}</strong>, 
              pero estás accediendo desde <strong className="font-semibold text-gray-900">{currentCountryName}</strong>.
            </p>
          </div>

          <div className="flex items-start space-x-3">
            <div className="w-6 h-6 rounded-full bg-yellow-100 flex items-center justify-center flex-shrink-0 mt-0.5">
              <FontAwesomeIcon icon={faGlobe} className="text-yellow-600 text-xs" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">Ubicación del Proyecto</p>
              <p className="text-xs text-gray-600 mt-1">
                Para ver este proyecto correctamente, accede desde el subdominio de {projectCountryName}.
              </p>
            </div>
          </div>
        </div>

        {/* Footer con botones */}
        <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors text-sm font-semibold"
          >
            Cerrar
          </button>
          <button
            onClick={onRedirect}
            className="flex-1 px-4 py-2.5 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors text-sm font-semibold flex items-center justify-center space-x-2"
          >
            <FontAwesomeIcon icon={faGlobe} className="text-sm" />
            <span>Ir a {projectCountryName}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CountryMismatchModal;

